export default __webpack_public_path__ + "static/media/logo-dark.24211ac1.png";